import React from 'react';
import { ModalBody, ServiceSelectionSubtitle } from '../styles/modalStyles';
import { ModalHeader } from './ModalHeader';
import { ModalFooter } from './ModalFooter';
import { WarrantyExclusivitySection } from './WarrantyExclusivitySection';
import { WarrantyOptionsGrid } from './WarrantyOptionsGrid';

export const WarrantySelectionStep = ({
  selectedWarrantyOption,
  onWarrantyOptionSelection,
  onBack,
  onClose,
  onProceed,
  isMobile = false,
}) => {
  return (
    <>
      <ModalHeader
        title="Garantias"
        onBack={onBack}
        onClose={onClose}
        isMobile={isMobile}
      />
      <ModalBody paddingBottom="0px">
        <ServiceSelectionSubtitle>
          Selecione o plano de garantia e solicite:
        </ServiceSelectionSubtitle>


        <WarrantyOptionsGrid
          selectedWarrantyOption={selectedWarrantyOption}
          onWarrantyOptionSelection={onWarrantyOptionSelection}
        />
      </ModalBody>
      <ModalFooter
        center={true}
        primaryButtonText="Prosseguir"
        onPrimaryClick={onProceed}
        primaryButtonDisabled={!selectedWarrantyOption}
        primaryButtonWidth="343px"
        primaryButtonMarginTop="0px"
      />
      <div style={{ padding: '0px 1rem 1rem 1rem' }}>
        <WarrantyExclusivitySection />
      </div>
    </>
  );
};
